import LoadPanel from 'devextreme-react/load-panel';
import 'devextreme/dist/css/dx.common.css';
import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from "react-query";
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, useHistory, useLocation } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css';
import { authApi } from './api/auth';
import app_info from './app-info';
import Content from './Content';
import { NavigationProvider } from './contexts/navigation';
import StoreProvider from "./contexts/common";

import { authActionTypes } from './state/reducers/authReducer';
import { useScreenSizeClass } from './utils/media-query';
const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}


function App() {

    const history = useHistory();
    const query = useQuery();
    const hash = query.get("hash");
    const user_id = query.get("user");
    const ticket_key = query.get("key");

    const { isLoading, user } = useSelector(x => x.auth)


    const dispatch = useDispatch();

    useEffect(() => {
        //lay user tu token

        if (user == undefined) {
            handleGetUserInfo();
        }
    }, [])
    useEffect(() => {
        //neu da lay user tu token
        if (user != undefined) {
            //neu da dang nhap nhung id khac nhau
            if (user.id > 0) {
                if (user_id != null && user_id != user.id) {
                    dispatch({ type: authActionTypes.LOGOUT.START })
                }
            } else {
                if (hash != null && ticket_key != null) {
                    handleLoginSSO();
                } else {
                    window.location.href = app_info.home_url + "/login?service=" + window.location.origin + "&system_id=" + app_info.sub_system_id;
                }
            }
        }
    }, [user, ticket_key])

    const handleGetUserInfo = async () => {

        dispatch({ type: authActionTypes.GET_INFO.START })
        const res = await authApi.getUser();
        if (res) {
            if (res.is_success) {
                dispatch({ type: authActionTypes.GET_INFO.SUCCESS, payload: res.data })
            } else {
                dispatch({ type: authActionTypes.GET_INFO.ERROR, payload: res.message ? res.message : "" })
            }
        } else {
            dispatch({ type: authActionTypes.GET_INFO.ERROR, payload: "" })
        }
    }
    const handleLoginSSO = async () => {

        dispatch({ type: authActionTypes.LOGIN.START })
        const res = await authApi.signInSSO(ticket_key, hash);
        if (res.is_success) {
            console.log({
                dispatch: { type: authActionTypes.LOGIN.SUCCESS, payload: res.data }
            });
            dispatch({ type: authActionTypes.LOGIN.SUCCESS, payload: res.data })
            // setTimeout(() => {
            //     history.push("/home")
            // }, 250);
        } else {
            dispatch({ type: authActionTypes.LOGIN.ERROR })
            window.location.href = app_info.home_url;
        }
    }
    // console.log({
    //     isLoading,
    //     user
    // });
    return (
        <>
            {isLoading && <LoadPanel visible={true} />}
            {!isLoading && user && user.id > 0 && <Content />}
        </>
    );

}


export default function () {
    const screenSizeClass = useScreenSizeClass();
    const queryClient = new QueryClient();
    return (
        <Router>
            {/* <AuthProvider> */}
            <StoreProvider>
                <NavigationProvider>
                    <QueryClientProvider client={queryClient}>
                        <div className={`app ${screenSizeClass}`}>
                            <App />
                        </div>
                    </QueryClientProvider>
                </NavigationProvider>
            </StoreProvider>
            {/* </AuthProvider> */}
        </Router>
    );
}
